import { Button, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { enableProfilePageExplorerLinks } from 'config/env'
import { selectFunderProfileInfo, selectIsFunderProfileDissolved } from 'store/selectors/profile'
import { CONTACT_PAGE } from 'utils/paths'
import FinancialView from './components/FinancialView'
import ContactsView from './components/ContactsView'
import { ActiveView, DissolvedView } from './components/AboutViews'

import { ReactComponent as Logo } from 'assets/logo-triangle.svg'

const ProfileAbout = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const {
    addresses,
    businessNumber,
    description,
    faxNumber,
    financialCommentary,
    fiscalPeriodEnd,
    funderAffiliations,
    funderContacts,
    funderFinancialHistories,
    funderPublications,
    language,
    mission,
    name,
    phoneNumber,
    phoneNumberExtension,
    primaryEmail,
    secondaryEmail,
    yearEstablished,
    contactNote,
    showAllActivities
  } = useSelector(selectFunderProfileInfo)
  const isFunderDissolved = useSelector(selectIsFunderProfileDissolved)

  return (
    <Grid container>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
        {isFunderDissolved ? (
          <DissolvedView
            name={name}
            description={description}
            funderAffiliations={funderAffiliations}
            businessNumber={businessNumber}
          />
        ) : (
          <>
            <ActiveView
              name={name}
              description={description}
              funderAffiliations={funderAffiliations}
              businessNumber={businessNumber}
              addresses={addresses}
              phoneNumber={phoneNumber}
              phoneNumberExtension={phoneNumberExtension}
              faxNumber={faxNumber}
              funderPublications={funderPublications}
              language={language}
              mission={mission}
              primaryEmail={primaryEmail}
              secondaryEmail={secondaryEmail}
              yearEstablished={yearEstablished}
              contactNote={contactNote}
            />
            <ContactsView funderContacts={funderContacts} />
            {enableProfilePageExplorerLinks && (
              <div className="profile-page-explorer-link">
                <div className="profile-page-explorer-logo">
                  <Logo />
                </div>
                <span>
                  <span>{t.funder.contactExplorerPrompt}</span>
                  <Link to={CONTACT_PAGE}>
                    <Button variant="contained">{t.contactExplorer.title}</Button>
                  </Link>
                </span>
              </div>
            )}
          </>
        )}
      </Grid>
      {!isFunderDissolved && (
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 7 }}>
          <FinancialView
            funderFinancialHistories={funderFinancialHistories}
            financialCommentary={financialCommentary}
            fiscalPeriodEnd={fiscalPeriodEnd}
            showAllActivities={showAllActivities}
          />
        </Grid>
      )}
    </Grid>
  )
}

ProfileAbout.isEnabled = () => true
ProfileAbout.tabPath = 'about'
ProfileAbout.getTabName = t => t.funder.about

export default ProfileAbout
